"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDatetimeSelectorMonthSelectorContainer = exports.StyledDatetimeSelectorLeftSection = exports.StyledDatetimeSelectorRightSection = exports.StyledDatetimeSelectorTimeSelector = exports.StyledDatetimeSelectorMonthYearSelectorHeader = exports.StyledDatetimeSelectorBody = exports.StyledDatetimeSelector = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../../helpers");
const TimeSelector_1 = require("../../../../helpers/components/TimeSelector/TimeSelector");
const Text_1 = require("../../../../Text");
exports.StyledDatetimeSelector = styled_components_1.default.div `
    position: relative;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
`;
exports.StyledDatetimeSelectorBody = styled_components_1.default.div `
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;
`;
exports.StyledDatetimeSelectorMonthYearSelectorHeader = (0, styled_components_1.default)(Text_1.Text) `
    height: ${helpers_1.SIZE_XL};
    line-height: ${helpers_1.SIZE_XL};
    margin-bottom: ${helpers_1.SPACING_S};
`;
exports.StyledDatetimeSelectorTimeSelector = (0, styled_components_1.default)(TimeSelector_1.TimeSelector) `
    padding-top: ${helpers_1.SPACING_XXL};
`;
exports.StyledDatetimeSelectorRightSection = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-left: 32px;

    ${({ hidden }) => hidden &&
    (0, styled_components_1.css) `
            visibility: hidden;
        `}
`;
exports.StyledDatetimeSelectorLeftSection = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
`;
exports.StyledDatetimeSelectorMonthSelectorContainer = styled_components_1.default.div `
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    right: 0;
`;
//# sourceMappingURL=DatetimeSelector.styles.js.map